import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface MasterCampaignPlanState {
  editMode: boolean
}

const initialState: MasterCampaignPlanState = {
  editMode: false
}

const masterCampaignPlanSlice = createSlice({
  name: 'masterCampaignPlan',
  initialState,
  reducers: {
    setEditMode: (state, action: PayloadAction<boolean>) => {
      state.editMode = action.payload
    },
    resetEditMode: state => {
      state.editMode = false
    }
  }
})

export const { setEditMode, resetEditMode } = masterCampaignPlanSlice.actions

export const selectEditMode = (state: { masterCampaignPlan: MasterCampaignPlanState }): boolean => {
  return state.masterCampaignPlan.editMode
}

export default masterCampaignPlanSlice.reducer